module.exports = __webpack_public_path__ + "static/media/arquitect_8.69492712.jpeg";